import { render, staticRenderFns } from "./CardsInfoCotizaciones.vue?vue&type=template&id=96224e0a&scoped=true&"
import script from "./CardsInfoCotizaciones.vue?vue&type=script&lang=js&"
export * from "./CardsInfoCotizaciones.vue?vue&type=script&lang=js&"
import style0 from "./CardsInfoCotizaciones.vue?vue&type=style&index=0&id=96224e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96224e0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
